import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/src/components/Applications/ApplicationsNav.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/ArticlesCarousel/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/ArticlesList.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/focusAreas/BackgroundGlow.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/header/Header.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/navigation/NavigationHomePage.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/navigation/NavigationHomePageMobile.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/NextImage/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/OpenArticleModal.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/ScrollDown/ScrollDown.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/SectionMorePartner/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/SectionTitle/SplitedText.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/SocialMedia/SocialMediaSidebar.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/SubSectionTitle.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/VideoBackground.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/VideoJS/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/VideoPlayer/index.tsx")